import { type Entity } from '@backstage/catalog-model';
import { isComponentType } from '@backstage/plugin-catalog';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

type EntityFilter = (entity: Entity) => boolean;

const anyOf =
  (...filters: EntityFilter[]): EntityFilter =>
  entity =>
    filters.some(filter => filter(entity));

const isServiceOrWebsiteComponent = anyOf(
  isComponentType('service'),
  isComponentType('website'),
);

const catalogDependenciesEntityContent = EntityContentBlueprint.make({
  name: 'driveline-dependencies',
  params: {
    path: '/dependencies',
    title: 'Dependencies',
    filter: isServiceOrWebsiteComponent,
    loader: () =>
      import('./CatalogDependenciesEntityContent').then(module => (
        <module.CatalogDependenciesEntityContent />
      )),
  },
});

export const catalogDependenciesEntityContentModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [catalogDependenciesEntityContent],
});
